"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var countdown_1 = tslib_1.__importDefault(require("./countdown"));
exports["default"] = countdown_1["default"];
tslib_1.__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map